class Validate {
  constructor (val, ctx) {
    this.val = val
    this._ctx = ctx
  }

  notEmpty () {
    if (this.val === '' || this.val === null || typeof this.val === 'undefined') {
      return this._ctx.$t('mixins.validate.mustNotBeEmpty')
    }
  }

  min (val) {
    if (this.val && +this.val < val) {
      return this._ctx.$t('mixins.validate.mustBeGreaterOrEqual', { val })
    }
  }

  max (val) {
    if (this.val && +this.val > val) {
      return this._ctx.$t('mixins.validate.mustBeLessOrEqual', { val })
    }
  }

  positive () {
    if (this.val && +this.val < 0) {
      return this._ctx.$t('mixins.validate.mustNotBeGreaterOrEqualZero')
    }
  }

  minLength (length) {
    if (this.val && this.val.length < length) {
      return this._ctx.$t('mixins.validate.minStringLength', { length })
    }
  }

  maxLength (length) {
    if (this.val && this.val.length > length) {
      return this._ctx.$t('mixins.validate.maxStringLength', { length })
    }
  }

  isEmail () {
    if (this.val && this.val.length && !/^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/.test(this.val)) {
      return this._ctx.$t('errors.code.validEmail')
    }
  }

  fractionDigitsMax (max) {
    if (!this.val) {
      return
    }
    const fr = (this.val.toString().includes('.')) ? (this.val.toString().split('.').pop().length) : (0)
    if (fr > max) {
      return this._ctx.$t('errors.code.maximumFractionDigits', { num: max })
    }
  }
}

export default {
  methods: {
    validate (val) {
      return new Validate(val, this)
    }
  }
}
